// Generated brand banners + infographic illustrations (nano banana / Gemini).
const B = "https://static.prod-images.emergentagent.com/jobs/f249d1a5-f649-4056-bd57-031b8d9a1e0e/images";

export const MEDIA = {
  homeHero: `${B}/567a73cdaac266211c3020567f8352cb275fff8f3a5ca4f527387566d269c415.jpeg`,
  infographicMethod: `${B}/3ce0c49bd15bde1de88f23977b7732e7b66bcbe98a173c3a1064e1ff0328fe16.jpeg`,
  bannerSupplyChain: `${B}/db8563762e8c67dc6d0abd2cd591f3bd423b332b27551d53f8f71ba82acee31a.jpeg`,
  bannerMarketing: `${B}/8cca9d2f8b9222a292a1ddcb513b4806262a0a256635a1cb71d7737df19d954d.jpeg`,
  bannerLearning: `${B}/5184d20843b3f9fc374a2e9b5fb8cee13c61942e0441e4782406b913afff3c8f.jpeg`,
  bannerIT: `${B}/6d7bcead192e6d3c55bcab0f4fe61fd92306552cf704b204c66c54082faef9cb.jpeg`,
  blogMarketing: `${B}/fd9f5aced7e8b3c1948019652d4ff6029180588518580e8179b70dec29fdfe8a.jpeg`,
  blogSupply: `${B}/05c4e0842a53294891f692f631e0d09e7dabf6d78223ddc0866bd123eb98b232.jpeg`,
  blogIT: `${B}/18fc2e20df98ca581529af222d0b84726e540a93b1c40e626d45f1618944dd09.jpeg`,
  blogEducation: `${B}/891d2e52afe0d613399225772496c8b9934a3e8bc43f7940dadc61c0a7e1f2af.jpeg`,
};
